


    
<mat-card class="padding-none">
    <mat-card-header class="padding-standard border-primary-bottom">
        <mat-card-title class="mat-headline-4">{{'ss-set-password.title' | translate}}</mat-card-title>
        <mat-card-subtitle class="mat-headline-6">{{'ss-set-password.subtitle' | translate}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="padding-standard">
        
        <ss-dynamic-form [controls]="controls" (formSubmit)="setPassword($event)">
            <div class="full-width flex-row-reverse">
                <button mat-raised-button color="accent" >{{'ss-set-password.set-password' | translate}}</button>
            </div>
            
        </ss-dynamic-form>

    </mat-card-content>
    
</mat-card>
    
